import { BulkTemplateRequest } from "../types/proposalDocuments.types";

import { apiFetch } from "./apiService";

const endpoints = {
  proposal: "/document-generation/proposal",
  customer_image_upload_url: "/document-generation/customer-image-upload-url",
  theme_previews_list: "/document-generation/assets/previews/themes/list",
  theme_preview: "/document-generation/assets/previews/themes",
  supplier_logos_list: "/document-generation/assets/suppliers/logos/list",
  supplier_logo: "/document-generation/assets/suppliers/logos",
  quote: "/document-generation/quote",
  get_url: "/document-generation/get-url",
  proposal_bulk_template: "/document-generation/proposal-bulk-template",
  proposal_bulk_submit: "/document-generation/proposal-bulk-submit",
};

const XLSX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// These wrap apiFetch and return the raw Response, matching what each call
// site already did before this consolidation, so component-side .ok/.json()
// handling doesn't need to change.

export const generateProposalDocument = (payload: unknown): Promise<Response> =>
  apiFetch(endpoints.proposal, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getCustomerImageUploadUrl = (contentType: string): Promise<Response> =>
  apiFetch(endpoints.customer_image_upload_url, {
    method: "POST",
    body: JSON.stringify({ content_type: contentType }),
  });

export const listThemePreviews = (): Promise<Response> => apiFetch(endpoints.theme_previews_list);

export const getThemePreview = (theme: string): Promise<Response> =>
  apiFetch(`${endpoints.theme_preview}/${theme}`);

export const listSupplierLogos = (): Promise<Response> => apiFetch(endpoints.supplier_logos_list);

export const getSupplierLogo = (supplierName: string): Promise<Response> =>
  apiFetch(`${endpoints.supplier_logo}/${supplierName}`);

export const generateQuoteDocument = (payload: unknown): Promise<Response> =>
  apiFetch(endpoints.quote, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getDocumentSignerUrl = (docId: string): Promise<Response> =>
  apiFetch(`${endpoints.get_url}?doc_id=${encodeURIComponent(docId)}`);

export const getBulkProposalTemplate = (payload: BulkTemplateRequest): Promise<Response> =>
  apiFetch(endpoints.proposal_bulk_template, {
    method: "POST",
    body: JSON.stringify(payload),
    // API Gateway only decodes Lambda's base64 body back to binary when the
    // Accept header matches one of its binaryMediaTypes - */* doesn't
    headers: { Accept: XLSX_MIME_TYPE },
  });

export const submitBulkProposalWorkbook = (file: File): Promise<Response> => {
  const formData = new FormData();
  formData.append("file", file);

  return apiFetch(endpoints.proposal_bulk_submit, {
    method: "POST",
    body: formData,
    omitContentType: true,
  });
};
